import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import { useLocalStorageWatcher } from '../../../utils/helpers/localStorage'
import AddNewButton from './AddNewButton'
import PageContent from './PageContent'
import PageHeader from './PageHeader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SideMenuTemplate from '../../../components/templates/v2/SideMenuTemplate'

const UsersListPage = () => {
  useLocalStorageWatcher('USERS_LAST_SCREEN', 'list')

  return (
    <SideMenuTemplate bgColor="white">
      <Separator weight={6} flex={1}>
        <PermissionChecker module="user">
          <FilterHandler tempStorageNamespace="users" initialState={{}}>
            <PageHeader />
            <PageContent />
          </FilterHandler>
          <AddNewButton />
          <Separator weight={90} />
        </PermissionChecker>
      </Separator>
    </SideMenuTemplate>
  )
}

export default UsersListPage
